
    import { Component, Emit, Prop, Vue } from "vue-property-decorator";
    import AdventureService from "../cuties/adventures/AdventureService";
    import type { PetGroupBattleOptionModeModel } from "@/cuties/model/pet/PetGroupBattleOptionModeModel";
    import AdventureListItem from "./AdventureListItem.vue";
    import type { PetGroupBattleOptionAdventureModel } from "@/cuties/model/pet/PetGroupBattleOptionAdventureModel";
    import type { PetBattleOptionsElement, ResponsePetBattleOptions } from "@/cuties/model/pet/ResponsePetBattleOptions";
    import DataHelpers from "@/cuties/engine/DataHelpers";
    import type AdventurePreviewModel from "@/cuties/model/adventure/AdventurePreviewModel";

    @Component({
        components: { AdventureListItem },
    })
    // Dark theme
    export default class SelectSendAdventure extends Vue {
        @Prop() private groupId: number;
        @Prop() private petIds: number[];
        @Prop() private sendAll: boolean;
        @Prop() private petId: number;
        @Prop() private singlePetAdventureTime: number;
        /**
         * must be set to true at once when user chose the adventure,
         * and stay true till request gets the response
         */
        @Prop({ required: true }) loading: boolean;

        private title: string;
        private descr: string;
        private localLoading = false;

        private adventures: PetGroupBattleOptionAdventureModel[] = null;
        private modes: PetGroupBattleOptionModeModel[] = null;
        private elements: Record<string, Record<string, PetBattleOptionsElement>> = null;
        private pendingCutiesCounts = null;

        created(): void {
            if (this.groupId != null) {
                this.localLoading = true;
                AdventureService.getAdventureListGroup(this.groupId)
                    .then((data) => {
                        this.initData(data);
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
                this.title = "adv_pop_title_group";
                this.descr = "adv_pop_descr_group";
            } else if (this.petIds != null) {
                this.localLoading = true;
                AdventureService.getAdventureListSelection(this.petIds)
                    .then((data) => {
                        this.initData(data);
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
                this.title = "adv_pop_title_sel";
                this.descr = "adv_pop_descr_sel";
            } else if (this.sendAll) {
                this.localLoading = true;
                AdventureService.getAdventureListAll()
                    .then((data) => {
                        this.initData(data);
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
                this.title = "adv_pop_title_all";
                this.descr = "adv_pop_descr_all";
            } else if (this.petId != null) {
                this.localLoading = true;
                AdventureService.getAdventureListSingle(this.petId)
                    .then((data) => {
                        this.initData(data);
                        if (data.elements != null) {
                            this.elements = data.elements;
                        }
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
                this.title = "adv_pop_title_single";
                this.descr =
                    this.$tc("adv_pop_descr_single1").toString() +
                    " " +
                    this.$tc("adv_cutie_will_take").toString() +
                    " " +
                    this.formatTime() +
                    " " +
                    this.$tc("adv_time_to_heal");
            }
            AdventureService.getMatchmakingStats().then(stats => {
                this.pendingCutiesCounts = Object.fromEntries(
                    stats.map(s => [s.location, s.pendingCutiesCount])
                );
            });
        }

        formatTime(): string {
            const time = DataHelpers.get_time_duration_digits(this.singlePetAdventureTime);
            const parts = time.split(":");
            const h = DataHelpers.toInt(parts[0]) * 24 + DataHelpers.toInt(parts[1]);
            let hour;
            if (h < 10 && h > 0) {
                hour = "0" + h;
            }
            if (h > 9) hour = h;
            if (h == 0) hour = "00";
            return hour + ":" + parts[2] + ":" + parts[3];
        }

        initData(data: ResponsePetBattleOptions): void {
            this.adventures = data.adventures;
            this.modes = data.modes;
        }

        isDisabled(model: PetGroupBattleOptionAdventureModel): boolean {
            return model.button && !model.button.active;
        }

        sendToAdventures(mode: PetGroupBattleOptionAdventureModel): void {
            if (this.isDisabled(mode)) {
                return;
            }
            if (this.petId != null) {
                this.sendToAdventure(mode.adventure);
            } else {
                this.emitSendToAdventures({ url: mode.button.ep, data: mode.button.epData, adventure: mode.adventure });
            }
        }

        @Emit("send-to-adventure")
        sendToAdventure(location: AdventurePreviewModel) {
            return location;
        }

        @Emit("send-to-adventures")
        emitSendToAdventures(payload: { url: string; data: unknown; adventure: AdventurePreviewModel }) {
            return payload;
        }
    }
